import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { AssignTechnicianComponent } from "../../assign-technician/assign-technician.component";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { ContentActionComponent } from "src/app/shared/content-action/content-action.component";
import { HttpErrorResponse } from "@angular/common/http";
import { Confirmation } from "src/app/enums/confirmation.enum";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";

@Component({
  selector: "fury-technician-table",
  templateUrl: "./technician-table.component.html",
  styleUrls: ["./technician-table.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class TechnicianTableComponent implements OnInit {
  @Input() columns: any[];
  @Input() itemList: any;
  @Input() dataSource: any = [];
  @Output() fetchTechnician: any = new EventEmitter();
  @Input() searchForm: FormGroup;
  @Output() search = new EventEmitter<any>();
  @Input() isLoading = false;
  ngUnsubscribe = new Subject<void>();
  technicianForm = new FormGroup({
    firstName: new FormControl("", [
      Validators.required,
      Validators.minLength(2),
    ]),

    lastName: new FormControl("", [
      Validators.required,
      Validators.minLength(2),
    ]),

    workOrderEmailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),

    workOrderPhoneNumber: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[2-9][0-8]\d{1}[2-9]\d{2}\d{4}$/),
    ]),

    status: new FormControl("", [Validators.required]),

    rating: new FormControl("", [Validators.required]),
  });

  constructor(public dialog: MatDialog, public apiService: ApiService) {}

  ngOnInit(): void {}
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  handleEditTechnician(technicianId) {
    const data = {
      editTechnician: true,
      companyForm: this.technicianForm,
      technicianId: technicianId,
    };

    this.dialog
      .open(AssignTechnicianComponent, {
        data: data,
        width: "800px",
        panelClass: "addCompany",
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.fetchTechnician.emit(false);
        if (res) {
          this.fetchTechnician.emit(res);
        }
      });
  }

  handleDeleteTechnician(technicianId: string) {
    const dialogref = this.dialog.open(ContentActionComponent, {
      width: "500px",
      data: { type: "delete" },
    });
    dialogref
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Confirmation) => {
        if (res === Confirmation.Yes) {
          this.deleteTechnician(technicianId);
        }
      });
  }
  deleteTechnician(technicianId) {
    this.apiService
      .delete(endpoints.partners.serviceProvider.deleteTechnician(technicianId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.apiService.alert(res?.body?.message, "success");
          this.fetchTechnician.emit(false);
          if (res) {
            this.fetchTechnician.emit(res);
          }
        },
        (err) => {
          this.apiService.alert(err.message, "error");
        }
      );
  }
  searchData() {
    if (!this.isLoading) this.search.emit(this.searchForm.value);
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
